import cn from 'classnames'
import { toast } from 'react-toastify'
import { type ReactElement } from 'react'
import { transactionsProxy } from '../../../../../../shared/proxies/transactionsProxy'
import { executeTransactionsExport } from '../executeTransactionsExport'

async function onClick (): Promise<void> {
  if (transactionsProxy.filters.startDate && transactionsProxy.filters.endDate) {
    if (transactionsProxy.filters.endDate < transactionsProxy.filters.startDate) {
      toast.warning('End date should be equal to or after start date')
      return
    }
  }

  await executeTransactionsExport({ displayLoader: true })
  toast.success('Your request is being processed. See your export requests under "My Account -> Data Exports"')
}

export function ExportToCsv (): ReactElement {
  return (
    <button
      className={
        cn(
          'text-wpy-blue-600 mr-2 w-48 flex justify-center items-center rounded hover:bg-gray-50 px-2 py-1'
        )
      }
      onClick={onClick}
    >
      <div className="text-lg font-semibold ml-1 ">Export CSV</div>
    </button>
  )
}
